import React from 'react';
import { useAuth } from '../../hooks/common/useAuth';
import { PERMISSION_SUBJECTS } from '../../constants/service/common/userPermissions';
import { PaymentSettingsWorkspace } from '../../views/pgProviderRoute/components/PaymentSettingsWorkspace';

export const PgProviderRouteContainer = (): React.JSX.Element => {
  const { can } = useAuth();
  return <PaymentSettingsWorkspace canUpdate={can('update', PERMISSION_SUBJECTS.PAYMENT_PG_ROUTE)} />;
};
